import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
	selector: 'app-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit
{
	public pageTitle;

	constructor(private location: Location,
	            private titleService: Title,
	            private router: Router,
	            private activatedRoute: ActivatedRoute)
	{
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				const title = this.getTitle(this.router.routerState, this.router.routerState.root).join('-');
				titleService.setTitle(title);
				this.pageTitle = title;
			}
		});
	}

	public getTitle(state, parent)
	{
		const data = [];
		if (parent && parent.snapshot.data && parent.snapshot.data.title) {
			data.push(parent.snapshot.data.title);
		}

		if (state && parent) {
			data.push(... this.getTitle(state, state.firstChild(parent)));
		}
		return data;
	}

	public back()
	{
		this.location.back();
	}

	ngOnInit()
	{
	}
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.component.ts